import type { ReactNode } from "react";
import Modal from "@shared/v2/Modal";
import Button from "@shared/v2/Button";
import FieldError from "@shared/v2/FieldError";

interface DeleteTemplateModalProps {
  show: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
  error?: string | null;
  /** Additional buttons rendered to the left of "Yes, Delete" */
  extraActions?: ReactNode;
  children: ReactNode;
}

const DeleteTemplateModal = ({
  show,
  onClose,
  onConfirm,
  loading = false,
  error = null,
  extraActions = null,
  children,
}: DeleteTemplateModalProps) => (
  <Modal
    show={show}
    onHide={onClose}
    dialogClassName="tw-flex tw-items-center tw-justify-center tw-h-full"
    contentClassName="tw-max-w-[480px] tw-max-h-[90vh] tw-w-full tw-flex tw-flex-col tw-gap-[32px]"
  >
    {/* @ts-expect-error props */}
    <Modal.Header title="Are you sure?" closeButton />
    <Modal.Body className="tw-flex tw-flex-col tw-gap-[12px] tw-my-[24px]">
      {children}
      {error && <FieldError error={error} />}
    </Modal.Body>
    <Modal.Footer className="tw-flex tw-flex-wrap-reverse tw-justify-between tw-gap-[8px]">
      {/* @ts-expect-error props */}
      <Button schema="tertiary" size="medium" onClick={onClose} disabled={loading}>
        Cancel
      </Button>
      <div className="tw-flex tw-gap-[8px]">
        {extraActions}
        {/* @ts-expect-error props */}
        <Button schema="warning" size="medium" onClick={onConfirm} isLoading={loading}>
          Yes, Delete
        </Button>
      </div>
    </Modal.Footer>
  </Modal>
);

export default DeleteTemplateModal;
